<template>
  <div class="container-fluid col-12 col-lg-10" id="container">

    <div class="calculadora-cabecalho">
      <nav class="breadcrumb-calculadora" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/" class="text-decoration-none">
            <b class="page-header-eyebrow">Projetos</b>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            :to="`/app/project/${calculo.codProjeto}`"
            class="text-decoration-none"
          >
            <b class="page-header-eyebrow">Projeto</b>
          </router-link>
        </li>        
        <li class="breadcrumb-item active" aria-current="page">Design Data</li>
      </ol>
      </nav>
      <div class="badges-calculadora">
        <span class="azul badge bg-primary"><b>Data de Criação: {{ converterDataBrasil(calculo.dataCriacao) }}</b></span>
        <span class="azul badge bg-primary"><b>Autor(a): {{ abreviarNome(calculo.autor) }}</b></span>
      </div>
    </div>

    <section class="calculadora-resumo calculadora-resumo-sem-imagem">
      <!-- PROJECT NAME -->
      <div class="calculadora-identificacao">
        <p class="page-header-eyebrow">CONFIGURAÇÃO DO PROJETO</p>
        <h1 class="calculadora-titulo">Design Data</h1>
        <p class="calculadora-subtitulo">
          Parâmetros gerais utilizados por todos os componentes.
        </p>
      </div>

    </section>

    <section class="calculadora-impressao">
      <div>
        <h2>Imprimir componente</h2>
        <p>Imprime um PDF com todos os dados do componente.</p>
      </div>
      <button type="button" class="btn btn-secundario" @click="imprimir()">
        Imprimir
      </button>
    </section>

    <!-- BOTÕES DE AÇÃO -->
    <div class="row g-2 justify-content-end">

      <!-- SALVAR -->
      <div class="col-6 col-md-auto">
        <button
          class="botao-azul btn btn-primary w-100"
          @click="salvarCalculo()"
        >
          Salvar
        </button>
      </div>

    </div>

    <DesignDataComponent :designDataProps="designData" ref="designDataForm" />

    <!-- BOTÕES DE AÇÃO -->
    <div class="row g-2 justify-content-end">

      <!-- SALVAR -->
      <div class="col-6 col-md-auto">
        <button
          class="botao-azul btn btn-primary w-100"
          @click="salvarCalculo()"
        >
          Salvar
        </button>
      </div>

    </div>
    
    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

  </div>
</template>

<script>
import { getUsuario } from '@/utils/authStorage';
// Componentes
import DesignDataComponent from '@/components/calculadoras/DesignDataComponent.vue';
import DesignData from '@/models/calculadoras/DesignData.js';
import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { logoBase64 } from './imgBase64/logoBase64.js';
import { jsPDF } from "jspdf";

// import { ManropeRegular } from "./fonts/Manrope-Regular-normal.js";

export default {
  name: "CalculatorDesignData",
  props: ["cod"],
  data() {
    return {
      calculo: {},
      designData: new DesignData(),
      usuarioLogado: null,

      // Modal de loading
      loadingModal: null,
      loadingModalAberto: false,

      // Modal de loading
      loading: {
        visible: false,
        title: 'Carregando dados',
        message: 'Aguarde um momento...'
      },

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },
    };
  },
  components: {
    DesignDataComponent,
    AlertModal,
    LoadingModal
  },
  mounted(){
    const usuarioSalvo = getUsuario();
    this.usuarioLogado = usuarioSalvo ? {
      ...usuarioSalvo,
      nome: usuarioSalvo.nome
    } : null;
    this.topoPagina();
    this.abrirLoading();
    this.carregarCalculo(this.cod);
  },
  created(){
    window.scrollTo(0, 0);
    this.topoPagina();
  },
  updated(){
    setTimeout(() => {
      this.topoPagina();
    }, 1);
  },
  methods: {

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    abreviarNome(nome) {
      if (!nome) return '';

      const partes = nome
        .trim()
        .split(' ')
        .filter(Boolean); // 🔑 remove strings vazias

      if (partes.length === 1) return partes[0];

      return `${partes[0]} ${partes[partes.length - 1]}`;
    },

    converterDataBrasil(data) {
      if (!data) return '';

      const partes = data.split('-');
      if (partes.length !== 3) return data;

      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },

    topoPagina() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    salvarCalculo() {
      if (!this.$refs.designDataForm.validarCamposObrigatorios()) {
        return;
      }

      let calculo = {
        cod: this.cod,
        designData: this.designData
      };

      fetch(`${process.env.VUE_APP_BACKEND_URL}/salvar-calculo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ calculo }),
        mode: 'cors',
      })
        .then(response => response.json())
        .catch(error => {
          console.error('Erro ao enviar dados para o servidor:', error);
        });
        this.abrirAlert(
          "Sucesso",
          "Dados salvos com sucesso.",
          "success"
        );
        this.topoPagina();
    },

    carregarCalculo(cod) {

      fetch(
        `${process.env.VUE_APP_BACKEND_URL}/buscar-calculo/${cod}?email=${this.usuarioLogado.email}`
      )
        .then(res => {

          // 🔐 BACKEND decide o acesso
          if (res.status === 401 || res.status === 403) {
            this.fecharLoading();
            window.location.href = '/';
            throw new Error('Acesso negado');
          }

          if (!res.ok) {
            throw new Error('Erro ao carregar cálculo');
          }

          return res.json();
        })
        .then(data => {

          if (!data || !data.calculo) {
            throw new Error('Resposta inválida do servidor');
          }

          // 1 - CARREGA CÁLCULO
          Object.assign(this.calculo, data.calculo);

          // 2 - DESIGN DATA (se existir)
          if (data.calculo.designData) {
            Object.assign(this.designData, data.calculo.designData);
          }

          // 3 - EXTRAS
          this.calculo.codUsuario = data.calculo.codUsuario;

          this.topoPagina();
        })
        .catch(err => {
          console.error('Erro ao carregar cálculo:', err);
        })
        .finally(() => {
          this.fecharLoading();
        });
    },

    adicionarPaginacao(doc) {
      const totalPaginas = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.height;

      for (let i = 1; i <= totalPaginas; i++) {
        doc.setPage(i);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(150);

        const texto = `Página ${i} de ${totalPaginas}`;
        const textWidth = doc.getTextWidth(texto);
        doc.text(texto, (pageWidth - textWidth) / 2, pageHeight - 10);

        doc.setTextColor(0);
      }
    },

    async imprimir() {
      this.loading = {
        visible: true,
        title: 'Gerando PDF',
        message: 'Aguarde enquanto o documento e preparado...'
      };
      await this.$nextTick();
      await new Promise(resolve => requestAnimationFrame(resolve));

      const doc = new jsPDF();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 15;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(text, 20, y);
      };

      const field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      const message = (text) => {
        checkPage();
        doc.setFont("helvetica", "italic");
        doc.setFontSize(12);
        doc.setTextColor(120);
        doc.text(text, 20, y);
        doc.setTextColor(0);
        y += 8;
      };

      /* =========================
        HEADER
      ========================== */
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;

      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);

      doc.link(logoX, y, logoW, logoH, {
        url: "https://wisecalc.com.br",
      });

      y += logoH + 25;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("DESIGN DATA", 20, y);
      y += 14;

      field("Autor(a)", this.calculo.autor || "N/A");

      field(
        "Data da Impressão",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      message("The parameters were used for all components used.");

      /* =========================
        1. PROJECT INFORMATION
      ========================== */
      y += 10;
      title("1. PROJECT INFORMATION");

      const d = this.designData;

      subtitle("GENERAL");
      y += 15;

      field("Job name", d.jobName);
      field("Job number", d.jobNumber);
      field("Tag number", d.tagNumber);
      field("Equipment description", d.equipmentDescription);

      y += 5;
      subtitle("DOCUMENT CONTROL");
      y += 15;

      field("Client", d.client);
      field("Document number", d.documentNumber);
      field("Prepared by", d.preparedBy);
      field("Checked by", d.checkedBy);
      field("Approved by", d.approvedBy);

      const reviewDate = d.reviewDate
        ? new Date(d.reviewDate).toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : "N/A";

      field("Review date", reviewDate);

      /* =========================
        2. VESSEL INFORMATION
      ========================== */
      y += 10;
      title("2. VESSEL INFORMATION");

      subtitle("PRESSURE");
      y += 15;
      
      field("Design Internal Pressure (P)", d.designInternalPressure, "MPa");
      field("Max Operation Pressure (P)", d.maxOperationPressure, "MPa");
      field("Design External Pressure", d.designExternalPressure, "MPa");

      y += 5;
      subtitle("TEMPERATURE");
      y += 15;

      field("Design Temperature (T)", d.designTemperature, "°C");
      field("Room Temperature", d.roomTemperature, "°C");

      y += 5;
      subtitle("FLUID");
      y += 15;

      field("Fluid", d.fluid);
      field("Density", d.density, "kg/m³");

      y += 5;
      subtitle("CONSTRUCTION");
      y += 15;

      field("Position", d.position);
      field("Volume", d.volume, "m³");
      field("Corrosion Allowance (c)", d.corrosionAllowance, "mm");
      field("Welded Joint Location", d.weldedJointLocation);
      field("Radiography", d.radiography);
      field("Post Weld Heat Treatment", d.postWeldHeatTreatment);
      field("Fluid Class - Brazilian NR-13", d.fluidClass);
      field("P.V", d.pv, "MPa·m³");
      field("Potential Risk Group (NR-13)", d.potentialRiskGroup);
      field("Category NR-13", d.categoryNR13);

      /* =========================
        SAVE
      ========================== */
      this.adicionarPaginacao(doc);
      doc.save(`(WiseCalc) ${this.calculo.nomeCalculo}.pdf`);
      this.fecharLoading();
    }
    
  }
};
</script>

<style scoped>
.documento {
  width: 210mm;
  min-height: 297mm;
  padding: 20mm;
  background: white;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
}

.cabecalho {
  text-align: center;
  border-bottom: 2px solid #000;
  margin-bottom: 20px;
}

.cabecalho .logo {
  width: 80px;
  margin-bottom: 10px;
}

.conteudo {
  margin-top: 20px;
}

.conteudo p {
  margin-bottom: 10px;
}

.rodape {
  position: absolute;
  bottom: 20mm;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: gray;
  border-top: 1px solid #ccc;
  padding-top: 5px;
}

.botao-outline-azul{
  border-color: #0056FF;
  background-color: white;
  color: #0056FF;
  font-weight: 600;
  height: 40px !important;
}

.botao-outline-azul:hover{
  border-color: #0056FF;
  background-color: #0056FF;
  color: white;
  font-weight: 600;
}
</style>